import React, { useEffect, useState } from 'react';
import TableContainer from './TableContainer';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './Header';
import TopRight from './TopRight';
import BootstrapDateRangePicker from './BootstrapDateRangePicker';
import Cookies from 'js-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import configData from "./config.json";
var CryptoJS = require("crypto-js");

function Reports() {

  // const [currency, setCurrency] = useState('USD');

  // eslint-disable-next-line
  const [apiError, setApiError] = useState(false);
  const [apiFetched, setApiFetched] = useState(false);

  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);

  
  // Fetch Data
  const doFetch = async (event) => {
    setApiFetched(false);
    let reportPostData;
    if(event === 'pageLoad') {
      let postData = [];
      postData['sdate'] = document.getElementById('hiddenDateRange').value.split(' - ')[0];
      postData['edate'] = document.getElementById('hiddenDateRange').value.split(' - ')[1];
      postData['email'] = JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).email;
      postData['type'] = JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).user_type;

      if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).google_id.length > 0){
        postData['platform'] = "google";
        postData['pub_ids'] = document.getElementById('google').value.split(",");
        document.getElementById('google').checked=true;
        postData['metrics'] = ["dt"];
        postData['dimensions'] = ["adx_aveImp","adx_clicks","adx_rev","adx_res","adx_req","adx_ctr"];

        setTimeout(function(){
          // console.log('Made Checked TRUE');
          document.getElementById('dt').checked=true;
          document.getElementById('dt').parentNode.classList.add('active');
          document.getElementById('adx_aveImp').checked=true;
          document.getElementById('adx_aveImp').parentNode.classList.add('active');
          document.getElementById('adx_clicks').checked=true;
          document.getElementById('adx_clicks').parentNode.classList.add('active');
          document.getElementById('adx_rev').checked=true;
          document.getElementById('adx_rev').parentNode.classList.add('active');
          document.getElementById('adx_res').checked=true;
          document.getElementById('adx_res').parentNode.classList.add('active');
          document.getElementById('adx_req').checked=true;
          document.getElementById('adx_req').parentNode.classList.add('active');
          document.getElementById('adx_ctr').checked=true;
          document.getElementById('adx_ctr').parentNode.classList.add('active');
        }, 500);
      }else if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).aniview_id.length > 0){
        postData['platform'] = "aniview";
        postData['pub_ids'] = document.getElementById('aniview').value.split(",");
        document.getElementById('aniview').checked=true;
        postData['metrics'] = ["dt"];
        setTimeout(function(){
          // document.getElementById('dt').checked=true;
        }, 500);
      }else if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).adkernel_id.length > 0){
        postData['platform'] = "adkernel";
        postData['pub_ids'] = document.getElementById('adkernel').value.split(",");
        // console.log('Made Checked TRUE');
        document.getElementById('adkernel').checked=true;
        postData['metrics'] = ["date"];
        postData['dimensions'] = ["rtb_pub_requests","rtb_pub_coverage","rtb_pub_impressions","rtb_pub_net_clicks","rtb_pub_revenue"];
        setTimeout(function(){
          document.getElementById('date').checked=true;
          document.getElementById('date').parentNode.classList.add('active');
          document.getElementById('rtb_pub_requests').checked=true;
          document.getElementById('rtb_pub_requests').parentNode.classList.add('active');
          document.getElementById('rtb_pub_coverage').checked=true;
          document.getElementById('rtb_pub_coverage').parentNode.classList.add('active');
          document.getElementById('rtb_pub_impressions').checked=true;
          document.getElementById('rtb_pub_impressions').parentNode.classList.add('active');
          document.getElementById('rtb_pub_net_clicks').checked=true;
          document.getElementById('rtb_pub_net_clicks').parentNode.classList.add('active');
          document.getElementById('rtb_pub_revenue').checked=true;
          document.getElementById('rtb_pub_revenue').parentNode.classList.add('active');
        }, 500);
      }
      reportPostData = postData;
    }else {
      reportPostData = event;
    }
    // Send POST Request
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ "sdate": reportPostData.sdate, "edate": reportPostData.edate, "email": reportPostData.email, "type": reportPostData.type, "platform": reportPostData.platform, "pub_ids": reportPostData.pub_ids, "metrics": reportPostData.metrics, "dimensions": reportPostData.dimensions}, null, 2),
    };
    try {
      fetch(configData.SERVER_URL+"/reportBuilder", requestOptions)
        .then(response => {
          return response.json()
        })
        .then(response => {
            if (response.success === true) {
              let headerColumnArr = [];
              let j = 0;
              for (let key in response.records[0]) {
                  headerColumnArr[j] = {
                      Header: (value) => {
                          if (key === 'dt' || key === 'date' ) {
                            return 'Date';
                          }else if(key === 'ad_id') {
                              return 'Ad ID';
                          }else if(key === 'ad_name') {
                              return 'Ad Name';
                          }else if(key === 'adCode') {
                              return 'Ad Unit Code';
                          }else if(key === 'cNetCode') {
                              return 'Child Network Code';
                          }else if(key === 'adx_aveImp') {
                              return 'Ad Impressions';
                          }else if(key === 'adx_clicks') {
                              return 'Clicks';
                          }else if(key === 'adx_ctr') {
                              return 'CTR %';
                          }else if(key === 'adx_rev') {
                              return 'Revenue';
                          }else if(key === 'adx_ecpm') {
                              return 'Avg eCPM';
                          }else if(key === 'adx_req') {
                              return 'Total Requests';
                          }else if(key === 'adx_matchRate') {
                              return 'Match %';
                          }else if(key === 'adx_reqECPM') {
                              return 'Total Requests eCPM';
                          }else if(key === 'adx_matchECPM') {
                              return 'Match Request eCPM';
                          }else if(key === 'adx_avvImp') {
                              return 'Viewable Impressions';
                          }else if(key === 'adx_avvImpRate') {
                              return 'Viewable Impressions %';
                          }else if(key === 'adx_res') {
                              return 'Responses Served';
                          }
                          // Adkernel
                          else if(key === 'zone') {
                            return 'Zone';
                          }else if(key === 'zone_id') {
                            return 'Zone Id';
                          }else if(key === 'site_domain') {
                            return 'Site';
                          }else if(key === 'app_bundle') {
                            return 'Application';
                          }else if(key === 'banner_size') {
                            return 'Banner Size';
                          }else if(key === 'country') {
                            return 'Country';
                          }else if(key === 'video_size_ex') {
                            return 'Video Size';
                          }else if(key === 'rtb_pub_requests') {
                            return 'Requests';
                          }else if(key === 'rtb_pub_coverage') {
                            return 'Responses';
                          }else if(key === 'rtb_pub_coverage_rate') {
                            return 'Coverage %';
                          }else if(key === 'rtb_pub_impressions') {
                            return 'Impressions';
                          }else if(key === 'rtb_pub_win_rate') {
                            return 'Impression Win %';
                          }else if(key === 'rtb_pub_net_clicks') {
                            return 'Clicks';
                          }else if(key === 'rtb_pub_ctr') {
                            return 'Gross CTR';
                          }else if(key === 'rtb_pub_revenue') {
                            return 'Revenue';
                          }else if(key === 'rtb_pub_ecpm') {
                            return 'eCPM';
                          }
                      },
                      accessor: key,
                      Cell: (value) => {
                          if (['adx_rev','adx_ecpm','adx_reqECPM','adx_matchECPM','rtb_pub_revenue','rtb_pub_ecpm'].includes(key)) {
                            const keyValue = value.value;
                            return <span><span className="dollar_icon">$</span>{keyValue}</span>
                          } else {
                            if (key === 'ad_id' || key === 'cNetCode' || key === 'app_bundle' || key === 'site_domain' || key === 'rtb_pub_ecpm') {
                              return value.value;
                            }else {
                              return value.value.toLocaleString('en-US');
                            }
                          }
                      },
                      Footer: (info) => {
                          if (['adx_rev','adx_ecpm','adx_reqECPM','adx_matchECPM','rtb_pub_revenue','rtb_pub_ecpm'].includes(key)) {
                            // const keyValue = info.value;
                            return <span><span className="dollar_icon">$</span>{response.totalArray[key].toLocaleString('en-US')}</span>
                          }else {
                            if(response.totalArray[key]) {
                              return response.totalArray[key].toLocaleString('en-US');
                            }else {
                              return response.totalArray[key];
                            }
                          }
                      },
                      
                      disableSortBy: false,
                      disableFilters: true,
                  }
                  j++;
              }
              setColumns(headerColumnArr);
              setTimeout(function(){
              setData(response.records);
              setApiFetched(true);
              }, 600);
            }else {
              // alert(response.message);
            }
        }).catch(error=>{
          // alert("There is some error in processing your request. Please try again in some time.");
          toast.error("There is some error in processing your request. Please try again in some time.");
        })
    } catch (error) {
    // console.log(`Error! ${error.message}`);
    }
  };

  useEffect(() => {
    doFetch('pageLoad');
  }, []);

  const pull_data2 = (fm) => {
    doFetch(fm);
  }

  const pull_data = (data) => {
    if (data === 'dateChanged') {
        let reportPostData = [];
        let metrix = [];
        let dimensions = [];
        reportPostData['sdate'] = document.getElementById('hiddenDateRange').value.split(' - ')[0];
        reportPostData['edate'] = document.getElementById('hiddenDateRange').value.split(' - ')[1];
        reportPostData['email'] = JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).email;
        reportPostData['type'] = JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).user_type;
        if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).google_id.length > 0){
            if (document.getElementById('google').checked) {
                reportPostData['platform'] = 'google';
                reportPostData['pub_ids'] = document.getElementById('google').value.split(",");
            }
        }
        if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).aniview_id.length > 0){
            if (document.getElementById('aniview').checked) {
                reportPostData['platform'] = 'aniview';
                reportPostData['pub_ids'] = document.getElementById('aniview').value.split(",");
            }
        }
        if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).adkernel_id.length > 0){
            if (document.getElementById('adkernel').checked) {
                reportPostData['platform'] = 'adkernel';
                reportPostData['pub_ids'] = document.getElementById('adkernel').value.split(",");
            }
        }

        var metricsCheckboxes = document.querySelectorAll('.metrics');
        var n = 0;
        for (var icmx = 0; icmx < metricsCheckboxes.length; icmx++) {
            if (metricsCheckboxes[icmx].checked) {
                metrix[n] = metricsCheckboxes[icmx].value;
                n++;
            }
        }

        var dimensionsCheckboxes = document.querySelectorAll('.dimensions');
        var m = 0;
        for (var icdx = 0; icdx < dimensionsCheckboxes.length; icdx++) {
            if (dimensionsCheckboxes[icdx].checked) {
                dimensions[m] = dimensionsCheckboxes[icdx].value;
                m++;
            }
        }

        reportPostData['metrics'] = metrix;
        reportPostData['dimensions'] = dimensions;

        doFetch({ "sdate": reportPostData.sdate, "edate": reportPostData.edate, "email": reportPostData.email, "type": reportPostData.type, "platform": reportPostData.platform, "pub_ids": reportPostData.pub_ids, "metrics": reportPostData.metrics, "dimensions": reportPostData.dimensions});
    }
  }

  if(Cookies.get('status')) {
    return (

      <div>
        <ToastContainer />
        <div>
          <div className="d-flex w-100 bg_light">
            <Header />
            <div className="w-100 p-24px">
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex mb-28px align-items-center">
                    <div className="header_content">
                      <h1 className="nav_heading">Reports</h1>
                    </div>
                    <div className="form_group ms-36px mb-0">
                      <BootstrapDateRangePicker page="reports" func={pull_data} />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <TopRight page='report' />
                </div>
              </div>
              <div className="row">
                <div className='col-md-12'>
                  <div className='card_content_data'>
                    <TableContainer
                      columns={columns}
                      data={data}
                      apiError={apiError}
                      pageServing="reports"
                      // defaultSortedColumn='DOMAIN'
                      defaultSortedColumn={(columns.length > 0) ? (apiFetched) ? columns[0].accessor : '' : ''}
                      apiFetch={apiFetched}
                      func={pull_data2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  } else {
    window.location.href = "/";
  }

}

export default Reports;